import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import nomenclatoare from '@/store/nomenclatoare';
import {getModule} from 'vuex-module-decorators';
import {CONFIG_ENV} from '@/config';
import {ServicesNomUsers} from '@/modules/ServicesNomUsers';
import user from '@/store/user';
import axios, {AxiosResponse} from 'axios';
import {ServicesNomCateg} from '@/modules/ServicesNomCateg';
import {ServicesNomTipDoc} from '@/modules/ServicesNomTipDoc';
import {ServicesHrOrg} from '@/modules/ServicesHrOrg';
import {ServicesRegistre} from '@/modules/ServicesRegistre';

//const EditNomCateg = () => import('@/components/EditNomCateg/EditNomCateg.vue').then(m => m.default)
interface iOptionUser{
    userid:string,
    name: string,
}

// @ts-ignore
@Component({components: {}
})
export default class Login extends Vue {
    public user: string = '';
    public password: string = '';
    public isPwd: boolean = true;


    public $refs: any;
    public storeNomenclatoare = getModule(nomenclatoare);
    public userStore=getModule(user);

    constructor() {
        super();
    }

    public getNomenclatoareAndGoToRequestedComponent(){
        console.log('%cgetNomenclatoareAndGoToRequestedComponent<-------------------------', "color: red;font-size:16px;")
        const vueInst = this;
        const willUpdateStoreNomCategFromDB = new Promise(
            (resolve, reject) => {
                console.log('%cwillUpdateStoreNomCategFromDB from app.ts', "color: red;font-size:16px;")
                const storeNomenclatoare = getModule(nomenclatoare);
                ServicesNomCateg.getNomCateg().then((presponse) => {
                    if (presponse.status === 'success') {
                        storeNomenclatoare.set_nomcategorii(JSON.parse(presponse.rows));
                        resolve('success');
                    } else {
                        reject('error');
                    }
                });
            });
        const willUpdateStoreNomTipDocsFromDB = new Promise(
            (resolve, reject) => {
                const storeNomenclatoare = getModule(nomenclatoare);
                ServicesNomTipDoc.getNomTipDoc().then((presponse) => {
                    if (presponse.status === 'success') {
                        storeNomenclatoare.set_nomtipdoc(JSON.parse(presponse.rows));
                        resolve('success');
                    }
                    else {
                        reject('error');
                    }
                });
            });
        const willUpdateStoreNomOrganizatiiFromDB = new Promise(
            (resolve, reject) => {
                const storeNomenclatoare = getModule(nomenclatoare);
                ServicesHrOrg.getNomOrganizatii().then((presponse) => {
                    if (presponse.status === 'success') {
                        storeNomenclatoare.set_nomorganizatii(presponse.rows);
                        resolve('success');
                    }
                    else {
                        reject('error');
                    }
                });
            })

        const willUpdateStoreNomRegistreFromDB = new Promise(
            (resolve, reject) => {
                const storeNomenclatoare = getModule(nomenclatoare);
                ServicesRegistre.getNomRegistre().then((presponse) => {
                    if (presponse.status === 'success') {
                        storeNomenclatoare.set_nomregistre(JSON.parse(JSON.stringify(presponse.rows)));
                        resolve('success');
                    }
                    else {
                        reject('error');
                    }
                });
            })

        const willUpdatePersoaneUtilizatoareDB = new Promise(
            (resolve, reject) => {
                const storeNomenclatoare = getModule(nomenclatoare);
                ServicesNomUsers.getNomPersoaneUtilizatoare().then((presponse) => {
                    if (presponse.status === 'success') {
                        storeNomenclatoare.set_nompersoane_utilizatoare(JSON.parse(JSON.stringify(presponse.rows)));
                        resolve('success');
                    }
                    else {
                        reject('error');
                    }
                });
            })
        //ServicesNomCateg.updateStoreNomCategFromDB();
        //ServicesNomTipDoc.updateStoreNomTipDocsFromDB();
        Promise.all([willUpdateStoreNomCategFromDB, willUpdateStoreNomTipDocsFromDB, willUpdateStoreNomRegistreFromDB, willUpdateStoreNomOrganizatiiFromDB, willUpdatePersoaneUtilizatoareDB])
            .then(result => {
                console.log('Promise.all cu succes!');
                //console.log(result); //["success", "success", "success", "success"]
                const appidToView=vueInst.$router.currentRoute.params.appid;
                const currentRouteName=vueInst.$router.currentRoute.name;
                if(currentRouteName == 'ViewDocument') {
                    vueInst.$router.push({name: 'ViewDocument', params: { appid: appidToView }}).catch(err => {console.log('already there')});
                }else{
                    vueInst.$router.push({name: 'Home'});
                }
            })
            .catch(error => console.log(`Error in executing getNomenclatoareAndGoToRequestedComponent ${error}`))
    }

    public login(){
        const vueInst = this;
        ServicesNomUsers.login(vueInst.user,vueInst.password).then(presult=>{
            if(presult.status=='success'){
                    console.log('%cS-a incarcat userul din baza de date', "color: blue;font-size:18px;");
                    vueInst.userStore.set_user(presult.user);
                    localStorage.setItem('token', presult.user.csrf_token);
                    localStorage.setItem('statusAuth', 'yes');
                    localStorage.setItem('userid', presult.user.userid);
                    localStorage.setItem('first_name', presult.user.first_name);
                    localStorage.setItem('last_name', presult.user.last_name);
                    vueInst.getNomenclatoareAndGoToRequestedComponent();
                    // @ts-ignore
                    vueInst.$eventHub.$emit('eventAfterLogin', {});

            }
        });
    }

    public created() {
        const vueInst = this;
    }

}
